import { Route, Routes } from "react-router-dom";
import Consulta from "./Consulta";
import Cadastro from "./Cadastro";

export default function Certificado() {
    return <>
        <Routes>
            <Route path="/" element={<Consulta />}></Route>
            <Route path="/adicionar" element={<Cadastro />}></Route>
        </Routes>
    </>;
}